import React, {useCallback, useEffect, useState} from 'react';
import {Box, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import {CLFBDetalle, schemaCLFBDetalle} from "../types/types";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {OperacionCLFBDetalleFields} from "../types/fields";
import {TextField} from "src/lib/itaptec/components_forms/src";
import {HttpCacheOperacion} from "../../../api/httpCacheOperacion";
import {AsyncSelect} from "../../../../../components/forms";
import Icon from "../../../../../@core/components/icon";


interface SeccionCLFBActivoProps {
  detalle: CLFBDetalle,
  codPais: number,
  permiteEditar: boolean,
  handleConfirm: (data: CLFBDetalle) => void
}

function CLFBDetalleActivo({
                             detalle,
                             codPais,
                             permiteEditar,
                             handleConfirm
                           }: SeccionCLFBActivoProps) {

  const [editable, setEditable] = useState<boolean>(false);
  const [freeSolo, setFreeSolo] = useState<boolean>(false);

  const {control, handleSubmit} = useForm<CLFBDetalle>({
    resolver: zodResolver(schemaCLFBDetalle),
    defaultValues: {
      ...detalle
    }
  })

  const watchActivoTipo = useWatch({control: control, name: OperacionCLFBDetalleFields.CodOperacionActivoTipo})

  const onUpdateDetalle: SubmitHandler<CLFBDetalle> = (data) => {
    handleConfirm(data)
  }

  const getOpciones = useCallback(() =>
      HttpCacheOperacion.getActivoTipos(codPais)
    , [])

  useEffect(() => {
    if (watchActivoTipo === null) {
      setFreeSolo(true)
    }
  }, [watchActivoTipo])


  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='nowrap'>
      {
        (permiteEditar && editable) ?
          !freeSolo ?

            <AsyncSelect
              control={control}
              name={OperacionCLFBDetalleFields.CodOperacionActivoTipo}
              label='Tipo Activo'
              fullWidth
              nullOptionLabel={'Otro'}
              loadOptions={getOpciones}
            />
            :
            <Stack direction={'row'}>
              <TextField
                <CLFBDetalle>
                control={control}
                name={OperacionCLFBDetalleFields.DescOperacionActivoTipo}
                label={'Tipo Activo'}
                fullWidth
                sx={{minWidth: '200px', width: '100%'}}
                autoFocus
              />
              <Tooltip title='Ver opciones'>
                <IconButton onClick={() => {
                  setFreeSolo(false)
                }}>
                  <Icon icon={'mdi:menu'}/>
                </IconButton>
              </Tooltip>
            </Stack>
          :
          <Typography noWrap variant='body2'>
            {detalle[OperacionCLFBDetalleFields.DescOperacionActivoTipo]}
          </Typography>
      }
      {
        permiteEditar &&
        (
          editable ?
            <Box display='flex' justifyContent='center' flexWrap='nowrap'>
              <Tooltip title='Cancelar'>
                <IconButton onClick={() => setEditable(false)}>
                  <CancelIcon color='error'/>
                </IconButton>
              </Tooltip>
              <Tooltip title='Confirmar'>
                <IconButton onClick={handleSubmit(onUpdateDetalle)}>
                  <CheckCircleIcon color='success'/>
                </IconButton>
              </Tooltip>
            </Box>
            :
            <Tooltip title='Editar'>
              <IconButton onClick={() => setEditable(true)}>
                <EditIcon color='info'/>
              </IconButton>
            </Tooltip>
        )
      }
    </Box>
  )
}

export default CLFBDetalleActivo;